/**
 * Per-line award decision on a `purchase_order_detail` row that came in
 * through the multi-vendor RFQ flow. Set when the buyer awards an RFQ
 * round and decides which (line, vendor) combinations win.
 *
 * - `PENDING`  — the PO is still in QUOTE status; no award decision
 *                made yet, or the line was not part of an RFQ batch
 *                that's been awarded. Default state.
 * - `AWARDED`  — buyer accepted this vendor's quote for this line.
 *                When the parent PO transitions QUOTE → RELEASED,
 *                only AWARDED details get operationally ordered.
 * - `NOT_AWARDED` — buyer received a quote on this line but chose
 *                another vendor. Stays on the PO record for audit
 *                history (so we can see "vendor B also quoted $X
 *                but lost"); receiving + fulfillment skip these
 *                rows.
 */
export enum PurchaseOrderDetailAwardStatus {
	PENDING = 'pending',
	AWARDED = 'awarded',
	NOT_AWARDED = 'not_awarded',
}

export type PurchaseOrderDetailAwardStatusKey =
	keyof typeof PurchaseOrderDetailAwardStatus;
export type PurchaseOrderDetailAwardStatusValue =
	(typeof PurchaseOrderDetailAwardStatus)[PurchaseOrderDetailAwardStatusKey];

export const PurchaseOrderDetailAwardStatusLabels: Record<
	PurchaseOrderDetailAwardStatusValue,
	string
> = {
	[PurchaseOrderDetailAwardStatus.PENDING]: 'Pending',
	[PurchaseOrderDetailAwardStatus.AWARDED]: 'Awarded',
	[PurchaseOrderDetailAwardStatus.NOT_AWARDED]: 'Not Awarded',
};
